import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { epicService } from '@services';

export const useEpics = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['epics', params],
    queryFn: () => epicService.getAll(params),
    enabled: options.enabled !== undefined ? options.enabled : !!params.projectId,
    ...options,
  });
};

export const useEpic = (id) => {
  return useQuery({
    queryKey: ['epic', id],
    queryFn: () => epicService.getById(id),
    enabled: !!id,
  });
};

export const useCreateEpic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: epicService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['epics'] });
    },
  });
};

export const useUpdateEpic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => epicService.update(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['epics'] });
      queryClient.invalidateQueries({ queryKey: ['epic', id] });
    },
  });
};

export const useDeleteEpic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: epicService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['epics'] });
    },
  });
};
